import { format } from 'date-fns';

export default (date, formatStyle) => {
  return format(new Date(date), formatStyle);
};
